import { defineComponent } from "vue";
import IconButton from "../../common/base/IconButton.vue.mjs";
import MoreIcon from "../../common/icons/MoreIcon.vue.mjs";
import useControl from "./useMoreControlHooks.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MoreControlPC",
  setup(__props) {
    const moreControlConfig = roomService.getComponentConfig("MoreControl");
    const { t, basicStore, sidebarName } = useControl();
    function toggleMoreSidebar() {
      if (basicStore.setSidebarOpenStatus && basicStore.sidebarName === "more") {
        basicStore.setSidebarOpenStatus(false);
        basicStore.setSidebarName("");
        return;
      }
      basicStore.setSidebarOpenStatus(true);
      basicStore.setSidebarName("more");
    }
    return { __sfc: true, moreControlConfig, t, basicStore, sidebarName, toggleMoreSidebar, IconButton, MoreIcon };
  }
});
export {
  _sfc_main as default
};
